import React, { Component, ReactNode, Suspense } from 'react'
import PropTypes from 'prop-types'
import Field from '../../../fields'

interface TeamMemberEditFormPersonalProps {
  fields: Record<string, any>
  formId: string
  style?: Record<string, any>
  teamMemberEnabled?: boolean
}

class TeamMemberEditFormPersonal extends Component<TeamMemberEditFormPersonalProps> {
  render(): ReactNode {
    const { fields, formId, style } = this.props

    return (
      <div style={style}>
        <div style={{ paddingBottom: 20 }}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            className="dateofbirth-field"
            keys="dateOfBirth"
            placeholders="DD-MM-YYYY"
            formId={formId}
            label="Date of Birth"
            type="birthdate"
            validationTypes="birthdate"
            values={fields}
          />
          </Suspense>
        </div>

        <div style={{ paddingBottom: 20 }}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            className="address-field"
            formId={formId}
            keys="address"
            label="Address"
            type="address"
            values={fields}
          />
          </Suspense>
        </div>
        <div style={{ paddingBottom: 20 }}>
          <Suspense fallback={<div>Loading...</div>}>
          <Field
            className="phonenumber-field"
            formId={formId}
            keys="phoneNumber"
            label="Personal Telephone Number"
            options={{
              phone: true,
              phoneRegionCode: 'GB',
            }}
            type="formattedText"
            values={fields}
          />
          </Suspense>
        </div>
        <div style={{ paddingBottom: 20 }}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            className="allergies-field"
            keys="hasAllergies"
            label="Allergies"
            formId={formId}
            options={[
              { value: 'Yes', label: 'Yes' },
              { value: 'None known', label: 'None known' },
            ]}
            type="radios"
            values={fields}
          />
          </Suspense>
        </div>
        <div style={{ paddingBottom: 20 }}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            dependsOn={{
              key: 'hasAllergies',
              value: 'Yes',
            }}
            keys="allergies"
            required
            label="Allergy Details"
            formId={formId}
            type="text"
            values={fields}
          />
          </Suspense>
        </div>
        <div style={{ paddingBottom: 20 }}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            className="startdate-field"
            keys="startDate"
            placeholders="DD-MM-YYYY"
            formId={formId}
            label="Start Date"
            type="date"
            values={fields}
          />
          </Suspense>
        </div>
        {this.props.teamMemberEnabled && (
          <div style={{ paddingBottom: 20 }}>
            <Suspense fallback={<div>Loading...</div>}>
            <Field
              className="enddate-field"
              keys="endDate"
              placeholders="DD-MM-YYYY"
              formId={formId}
              label="End Date"
              type="date"
              values={fields}
            />
            </Suspense>
          </div>
        )}
        <div style={{ paddingBottom: 20 }}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            formId={formId}
            keys={['emergencyContactName.first', 'emergencyContactName.last']}
            label="Emergency Contact"
            placeholders={['First name', 'Last name']}
            type="multiText"
            values={fields}
          />
          </Suspense>
        </div>
        <div style={{ paddingBottom: 20 }}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            formId={formId}
            keys="emergencyContactRelation"
            label="Emergency Contact Relation"
            type="text"
            values={fields}
          />
          </Suspense>
        </div>
        <div style={{ paddingBottom: 20 }}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            className="emergencynumber-field"
            formId={formId}
            keys="emergencyContactNumber"
            label="Emergency Contact Telephone"
            options={{
              phone: true,
              phoneRegionCode: 'GB',
            }}
            type="formattedText"
            values={fields}
          />
          </Suspense>
        </div>
      </div>
    )
  }
}

export default TeamMemberEditFormPersonal
